import React, { useState } from 'react';
import { useTranslator } from 'tradera/lang/translate';
import { localStore } from 'tradera/utils/storage';
import { STORAGE_KEYS, STORAGE_VALUES } from 'tradera/constants/storage';
import HeaderImageLg from './mao-feature-modal-active-3x.png';
import HeaderImageMd from './mao-feature-modal-active-2x.png';
import HeaderImageSm from './mao-feature-modal-active-1x.png';
import { Heading } from 'tradera/components/atoms/heading/heading';
import { ScrollableModal } from 'tradera/components/scrollable-modal/scrollable-modal';
import { HeaderWithImage } from 'tradera/components/scrollable-modal/header-with-image';

const shouldShowMaoFeatureModal = () =>
    localStore &&
    localStore.getItem(STORAGE_KEYS.FEATURE_MODAL_MAO_ACTIVE) !==
        STORAGE_VALUES.FEATURE_MODAL_MAO_DISMISSED_CLICKED;

const hideMaoFeatureModal = () =>
    localStore &&
    localStore.setItem(
        STORAGE_KEYS.FEATURE_MODAL_MAO_ACTIVE,
        STORAGE_VALUES.FEATURE_MODAL_MAO_DISMISSED_CLICKED
    );

export const MakeAnOfferFeatureModal = () => {
    const { t } = useTranslator();
    const [showModal, setShowModal] = useState(shouldShowMaoFeatureModal());

    const handleCloseModal = () => {
        hideMaoFeatureModal();
        setShowModal(false);
    };

    return (
        <ScrollableModal
            show={showModal}
            onClose={handleCloseModal}
            header={
                <HeaderWithImage
                    preTitle={t('make_offer_modal_pre_title')}
                    mainTitle={t('make_offer_modal_active_main_title')}
                    imgSrc={HeaderImageLg}
                    srcSet={{
                        small: HeaderImageSm,
                        medium: HeaderImageMd,
                        large: HeaderImageLg
                    }}
                    tallImage
                />
            }>
            <>
                <Heading branded as="h5" className="mb-1">
                    {t('make_offer_modal_active_content_header')}
                </Heading>
                <p>{t('make_offer_modal_active_content')}</p>
            </>
        </ScrollableModal>
    );
};
